import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Formik } from 'formik'
import * as Yup from 'yup'

import { ProductIds } from 'core'
import editLoginUsername, {
  UserToEditLogin,
} from 'core/application/adminDashboard/managePeople/viewPeople/editLoginUsername'

import { commandRequest } from 'common/RequestUtils'
import { Button, Col, DefaultInput, Modal, Notification, Row } from 'common/components'

interface EditUsernameProps {
  visible: boolean
  userToEdit: UserToEditLogin
  onCancel: () => void
  afterSuccessEdit: () => void
}

const EditLoginUsernameModal: React.FC<EditUsernameProps> = (props) => {
  const { t: translate } = useTranslation('translation')
  const [loading, setLoading] = useState<boolean>(false)
  const [isFormValid, setIsFormValid] = useState<boolean>(true)

  let submitFormHandler: () => Promise<any> = () => new Promise(() => {})

  const onSubmit = async (values: UserToEditLogin) => {
    setLoading(true)
    const result = await commandRequest(() => editLoginUsername(values))
    setLoading(false)
    if (!result.errors) {
      Notification.open({
        message: translate('admin-dashboard.manage-people.username-update-success'),
        type: 'success',
      })
      props.afterSuccessEdit()
    } else {
      Notification.open({
        message: result.errors[0],
        type: 'error',
      })
    }
  }

  const formValidator = (translate: (key: string) => string) =>
    Yup.object({
      username: Yup.string()
        .nullable()
        .required(translate('general.required'))
        .email(translate('admin-signup.signup.errors.email')),
    })

  const modalFooterActions = [
    <Button key="back" onClick={props.onCancel}>
      {translate('general.cancel')}
    </Button>,
    <Button key="submit" disabled={!isFormValid} loading={loading} onClick={() => submitFormHandler()}>
      {translate('general.save')}
    </Button>,
  ]

  return (
    <Modal
      title={translate('admin-dashboard.manage-people.edit-username-header').replace(
        '[First Last Name]',
        props.userToEdit.fullName,
      )}
      visible={props.visible}
      destroyOnClose
      closable
      onCancel={props.onCancel}
      footer={modalFooterActions}
    >
      <div>
        <div className="mt-5">
          {translate('admin-dashboard.manage-people.username-update-desc')} <br />{' '}
        </div>
      </div>
      <div className="mt-16">
        <Formik
          enableReinitialize={true}
          validationSchema={formValidator(translate)}
          initialValues={props.userToEdit}
          onSubmit={onSubmit}
          validate={(values) => {
            setIsFormValid(formValidator(translate).isValidSync(values))
          }}
        >
          {(formik) => {
            const { handleSubmit, submitForm } = formik
            submitFormHandler = submitForm
            return (
              <form onSubmit={handleSubmit} autoComplete="off">
                <Row>
                  <Col span={24}>
                    <DefaultInput
                      label={translate('admin-dashboard.manage-people.username-label')}
                      name="username"
                      id="username"
                    />
                  </Col>
                </Row>
              </form>
            )
          }}
        </Formik>
      </div>
    </Modal>
  )
}

export default EditLoginUsernameModal
